import {useState} from "react";
import {
    Box,
    VStack,
    Input,
    InputGroup,
    InputLeftElement,
    Text,
    IconButton,
    Flex,
    useBreakpointValue
} from "@chakra-ui/react";
import {SearchIcon, ChevronLeftIcon, ChevronRightIcon} from "@chakra-ui/icons";
import colors from '../../theme/colors';
import {formatStrategyName} from '../../utilities/formatStrategyName';
import './strategySidebar.scss';

const StrategySidebar = ({strategies, selectedStrategy, setSelectedStrategy}) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [isCollapsed, setIsCollapsed] = useState(false);

    // Responsive: auto-collapse su mobile
    const isMobile = useBreakpointValue({base: true, md: false});

    const filteredStrategies = strategies
        .filter(strategy =>
            strategy.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    const toggleCollapse = () => {
        setIsCollapsed(prev => !prev);
    };

    return (
        <Box className={`strategy-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
            {/* Toggle button */}
            <IconButton
                icon={isCollapsed ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
                onClick={toggleCollapse}
                className="collapse-button"
                size="sm"
                aria-label={isCollapsed ? "Espandi sidebar" : "Chiudi sidebar"}
            />

            {!isCollapsed && (
                <VStack spacing={4} align="stretch" p={4} h="100%">
                    {/* Search box */}
                    <InputGroup>
                        <InputLeftElement pointerEvents="none">
                            <SearchIcon color="gray.400"/>
                        </InputLeftElement>
                        <Input
                            placeholder="Cerca strategia..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            bg="white"
                            borderRadius="md"
                            _focus={{
                                borderColor: colors.greenLight,
                                boxShadow: `0 0 0 1px ${colors.greenLight}`
                            }}
                        />
                    </InputGroup>

                    {/* Title */}
                    <Text fontSize="sm" fontWeight="bold" color="gray.600" textTransform="uppercase">
                        Strategie ({filteredStrategies.length})
                    </Text>

                    {/* Strategy list */}
                    <VStack spacing={1} align="stretch" flex="1" overflowY="auto" className="strategy-list">
                        {filteredStrategies.length === 0 ? (
                            <Text fontSize="sm" color="gray.500" textAlign="center" py={4}>
                                Nessuna strategia trovata
                            </Text>
                        ) : (
                            filteredStrategies.map((strategy, index) => {
                                const originalIndex = strategies.indexOf(strategy);
                                const isSelected = selectedStrategy === originalIndex;

                                return (
                                    <Flex
                                        key={index}
                                        className={`strategy-item ${isSelected ? 'selected' : ''}`}
                                        onClick={() => setSelectedStrategy(originalIndex)}
                                        align="center"
                                        justify="space-between"
                                        p={3}
                                        borderRadius="md"
                                        cursor="pointer"
                                        bg={isSelected ? colors.greenDark : "white"}
                                        color={isSelected ? "white" : "gray.700"}
                                        _hover={{
                                            bg: isSelected ? colors.greenLight : "gray.100",
                                            transform: "translateX(2px)",
                                            transition: "all 0.2s"
                                        }}
                                        transition="all 0.2s"
                                        boxShadow={isSelected ? "md" : "sm"}
                                    >
                                        <Text fontSize="sm" fontWeight={isSelected ? "bold" : "medium"}>
                                            {formatStrategyName(strategy)}
                                        </Text>
                                        {isSelected && (
                                            <Box
                                                w="8px"
                                                h="8px"
                                                borderRadius="full"
                                                bg="white"
                                            />
                                        )}
                                    </Flex>
                                );
                            })
                        )}
                    </VStack>
                </VStack>
            )}
        </Box>
    );
};

export default StrategySidebar;
